/**
 * SubscriptionModels Pinia Store
 *
 * MIGRATION FROM VUEX:
 * Replaces resources/assets/js/vuex/stores/subscriptionmodels.js
 */

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getCurrentStorageUser } from '../../common/localStorage/currentStorageUser'

export const useSubscriptionModelsStore = defineStore('subscriptionModels', () => {
    const allSubscriptionModels = ref([])
    const currentSubscriptionModel = ref(undefined)

    const extensionSubscriptionModel = computed(() =>
        allSubscriptionModels.value.find((sm) => sm.typ === 'extension')
    )

    const subscriptionModelWithID = computed(() => (id) =>
        allSubscriptionModels.value.find((sm) => sm.id === id)
    )

    const setAllSubscriptionModels = (subscriptionModels) => {
        allSubscriptionModels.value = subscriptionModels
        persistToLocalStorage()
    }

    const setCurrentSubscriptionModelByID = (id) => {
        currentSubscriptionModel.value = allSubscriptionModels.value.find(
            (sm) => sm.id == id
        )
        persistToLocalStorage()
    }

    const getPiniaStorageKey = () => {
        return getCurrentStorageUser() + '@pinia'
    }

    const persistToLocalStorage = () => {
        const key = getPiniaStorageKey()
        try {
            let data = {}
            const stored = localStorage.getItem(key)
            if (stored) {
                try {
                    data = JSON.parse(stored)
                } catch (e) {
                    console.warn('Failed to parse existing Pinia localStorage, creating new:', e)
                    data = {}
                }
            }

            data.subscriptionModelsStore = {
                allSubscriptionModels: allSubscriptionModels.value,
                currentSubscriptionModel: currentSubscriptionModel.value,
            }

            localStorage.setItem(key, JSON.stringify(data))
        } catch (e) {
            if (e.name === 'QuotaExceededError' || e.message.includes('quota')) {
                console.warn('🛒 QuotaExceededError detected in subscriptionModels store')
                throw e
            }
        }
    }

    const loadFromLocalStorage = () => {
        const key = getPiniaStorageKey()
        try {
            const stored = localStorage.getItem(key)
            if (stored) {
                const data = JSON.parse(stored)
                if (data.subscriptionModelsStore) {
                    const modelsData = data.subscriptionModelsStore
                    if (modelsData.allSubscriptionModels) {
                        allSubscriptionModels.value = modelsData.allSubscriptionModels
                    }
                    if (modelsData.currentSubscriptionModel) {
                        currentSubscriptionModel.value = modelsData.currentSubscriptionModel
                    }
                }
            }
        } catch (e) {
            console.warn('Failed to load subscription models from localStorage:', e)
        }
    }

    loadFromLocalStorage()

    return {
        allSubscriptionModels,
        currentSubscriptionModel,
        extensionSubscriptionModel,
        subscriptionModelWithID,
        setAllSubscriptionModels,
        setCurrentSubscriptionModelByID,
    }
})
